define('home/templates/commentCardPostActions',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return " active";
},"3":function(container,depth0,helpers,partials,data) {
    return container.escapeExpression(container.lambda((depth0 != null ? depth0.likes : depth0), depth0));
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : {}, alias2=container.lambda, alias3=container.escapeExpression;

  return "<a href=\"#\" class=\"vote-up"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.sessionUserHasUpvoted : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\" data-action=\"vote\" data-vote=\"1\">\n<span class=\"vote__count text-gray text-small\" data-role=\"upvotes\">\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.likes : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n</span>\n<span class=\"icon-arrow-up icon-tiny\"></span>\n</a>\n\n<a href=\"#\" class=\"vote-down"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.sessionUserHasDownvoted : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\" data-action=\"vote\" data-vote=\"-1\">\n<span class=\"icon-arrow-down icon-tiny\"></span>\n</a>\n\n"
    + ((stack1 = container.invokePartial(partials.replyOrEditLink,depth0,{"name":"replyOrEditLink","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "\n<a href=\""
    + alias3(alias2((depth0 != null ? depth0.discussionRoute : depth0), depth0))
    + "#comment-"
    + alias3(alias2((depth0 != null ? depth0.id : depth0), depth0))
    + "\"\nclass=\"view-comment link-gray\"\ndata-link-name=\"view_comment\"\ndata-thread-id=\""
    + alias3(alias2(((stack1 = (depth0 != null ? depth0.thread : depth0)) != null ? stack1.id : stack1), depth0))
    + "\">\n\n<span class=\"visible-md\">"
    + alias3(helpers.gettext.call(alias1,"View",{"name":"gettext","hash":{},"data":data}))
    + "</span>\n<span class=\"hidden-md\">"
    + alias3(helpers.gettext.call(alias1,"View in discussion",{"name":"gettext","hash":{},"data":data}))
    + "</span>\n</a>\n";
},"usePartial":true,"useData":true})

});
